// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  GeoLocation,
} from "./types";


export default __t.row({
  stepId: __t.string().primaryKey().name("step_id"),
  projectId: __t.string().name("project_id"),
  displayName: __t.string().name("display_name"),
  get location() {
    return GeoLocation;
  },
  durationMinutes: __t.u32().name("duration_minutes"),
});
